import React from "react";
import { Chat, Phone, Email, Sync, Cloud, Speed, Security, Settings, TrendingUp } from "@material-ui/icons";
import { Button } from "@material-ui/core";
import Configs from "../../Assets/editable-stuff/configurations.json";

const AutomationServicesGrid = () => {
  const services = [
    {
      id: "workflow",
      icon: <Sync />,
      title: "Workflow Automation",
      description: "Connect your apps and automate workflows. When something happens in one app, trigger actions in others automatically.",
      color: "#8b5cf6"
    },
    {
      id: "data",
      icon: <Cloud />,
      title: "Data Sync & Migration",
      description: "Keep your data synchronized across all platforms. Migrate data between systems without manual effort.",
      color: "#06b6d4"
    },
    {
      id: "process",
      icon: <Speed />,
      title: "Process Optimization",
      description: "Streamline your business processes. Identify bottlenecks and implement automated solutions.",
      color: "#10b981"
    },
    {
      id: "integration",
      icon: <Settings />,
      title: "Custom Integrations",
      description: "Build custom integrations between your favorite tools. We connect systems that don't natively talk to each other.",
      color: "#f59e0b"
    },
    {
      id: "security",
      icon: <Security />,
      title: "Secure Automation",
      description: "Enterprise-grade security for all automations. Your data stays protected while workflows run seamlessly.",
      color: "#ef4444"
    },
    {
      id: "reporting",
      icon: <TrendingUp />,
      title: "Automated Reporting",
      description: "Generate reports automatically. Get insights delivered to your inbox without lifting a finger.",
      color: "#6366f1"
    }
  ];

  const howItWorks = [
    {
      step: "01",
      title: "Start with a Trigger",
      description: "Pick an event that starts your automation - a new email, form submission, or scheduled time."
    },
    {
      step: "02",
      title: "Add Actions",
      description: "Choose what happens next - send notifications, update databases, create files, and more."
    },
    {
      step: "03",
      title: "Let It Run",
      description: "Your automation runs 24/7. Focus on what matters while the repetitive work handles itself."
    }
  ];

  return (
    <section id="automationServices" className="services-section automation-services">
      <div className="services-container">
        <div className="section-header">
          <span className="section-label">Our Services</span>
          <h2 className="section-title">Automation That Works For You</h2>
          <p className="section-subtitle">
            Connect your apps, automate your tasks, and reclaim your time
          </p>
        </div>

        <div className="services-grid-modern services-grid-3col">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="service-card-modern"
              style={{ '--accent-color': service.color }}
            >
              <div className="service-card-header">
                <div className="service-icon-wrapper service-icon-mui">
                  {service.icon}
                </div>
                <span className="service-number">0{index + 1}</span>
              </div>

              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>

              <div className="service-actions">
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Phone />}
                  href={"tel: " + Configs.PhoneNumber}
                >
                  Call
                </Button>
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Chat />}
                  href={"sms: " + Configs.PhoneNumber + "&body=" + Configs.automationTemplate}
                >
                  Text
                </Button>
                <Button
                  className="service-btn"
                  variant="outlined"
                  size="small"
                  startIcon={<Email />}
                  href={"mailto: " + Configs.EmailAddress + "?subject=" + Configs.automationSubject + "&body=" + Configs.automationTemplate}
                >
                  Email
                </Button>
              </div>
            </div>
          ))}
        </div>

        {/* How It Works Section */}
        <div className="how-it-works-section">
          <h3 className="hiw-title">How It Works</h3>
          <div className="hiw-steps">
            {howItWorks.map((item, index) => (
              <div key={index} className="hiw-step">
                <div className="hiw-step-number">{item.step}</div>
                <h4 className="hiw-step-title">{item.title}</h4>
                <p className="hiw-step-desc">{item.description}</p>
                {index < howItWorks.length - 1 && <div className="hiw-connector"></div>}
              </div>
            ))}
          </div>
        </div>

        <div className="cta-banner cta-banner-automation">
          <div className="cta-content">
            <h3>Ready to automate?</h3>
            <p>Let's discuss how automation can transform your workflow and save you hours every week.</p>
          </div>
          <div className="cta-actions">
            <Button
              className="cta-btn-primary"
              variant="contained"
              startIcon={<Phone />}
              href={"tel: " + Configs.PhoneNumber}
            >
              Get Started
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AutomationServicesGrid;
